import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { icons } from "utils/constants";
import { Button } from "components";
import { ceil, floor } from "lodash";
import moment from "moment";
import { getTransactionHistory } from "store/globalSlice";
import "./Transaction.scss";

const globalLimit = 10;
const Transaction = ({ setShow, tokenBalance }) => {
  const reduxData = useSelector((state) => state.global);
  const { globalChainID, isDarkMode } = reduxData || {};
  const dispatch = useDispatch();
  const [pageLoading, setPageLoading] = useState(true);
  const [tableData, setTableData] = useState({
    networks: "",
    searchText: "",
    sortField: "",
    sortType: "",
    offset: 1,
    limit: globalLimit,
    total: 0,
    data: [],
  });

  const fetchTransactionData = async () => {
    const res = await dispatch(getTransactionHistory(globalChainID));
    const list = res?.data || [];
    setPageLoading(false);
    setTableData((prev) => {
      return {
        ...prev,
        total: list.length,
        data: list,
        offset: 1,
      };
    });
  };
  const handlePagination = (type, data) => {
    switch (type) {
      case "next":
        setTableData((prev) => {
          return { ...prev, offset: data.activePage * tableData.limit + 1 };
        });
        break;
      case "prev":
        setTableData((prev) => {
          return { ...prev, offset: tableData.offset - tableData.limit };
        });
        break;
      case "limit":
        setTableData((prev) => {
          return { ...prev, offset: 1, limit: data.limitset };
        });
        break;
      case "page":
        setTableData((prev) => {
          return {
            ...prev,
            offset: data.page * tableData.limit - tableData.limit + 1,
          };
        });
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    fetchTransactionData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalChainID]);
  const { offset, limit, data } = tableData;
  let displayList = data?.map((elem, index) => {
    const { timestamp } = elem;

    return {
      ...elem,
      rank: index + 1,
      date: moment.unix(timestamp).format("DD MMM, YYYY"),
      time: moment.unix(timestamp).format("hh:mm A"),
    };
  });

  const headerOption = [
    {
      elemValue: <div className="un header-option w5" />,
    },
    {
      elemValue: <div className="un header-option w10">#</div>,
    },
    {
      elemValue: <div className="un header-option w25">Date</div>,
    },
    {
      elemValue: <div className="un header-option w20">Amount</div>,
    },
    {
      elemValue: <div className="un header-option"></div>,
    },
    {
      elemValue: <div className="un header-option w20">No. query</div>,
    },
    {
      elemValue: <div className="un header-option">Allocated type</div>,
    },
  ];

  let total = displayList.length;

  const totalPage = ceil(total / limit);
  const activePage = floor(offset / limit + 1);
  let page1 = activePage;
  let page2 = activePage + 1;
  let page3 = activePage + 2;
  if (activePage >= totalPage - 2) {
    page1 = totalPage - 2 <= 0 ? 1 : totalPage - 2;
    page2 = totalPage - 1 <= 1 ? 2 : totalPage - 1;
    page3 = totalPage - 0 <= 2 ? 3 : totalPage - 0;
  }
  displayList = displayList.slice(offset - 1, activePage * limit);
  let option = [];
  if (total >= 5) {
    option.push(5);
  }
  if (total > 5) {
    option.push(10);
  }
  if (total > 10) {
    option.push(15);
  }
  if (total > 15) {
    option.push(20);
  }
  if (total > 20) {
    option.push(total);
  }
  const rowData = [];
  displayList.forEach((e) => {
    const { rank, date, time, queries, amount, currency } = e;
    rowData.push({
      rowValue: (
        <div className="row-block">
          <div className="row-cell w5" />
          <div className="row-cell w10">{rank}</div>
          <div className="row-cell w20">
            <div>{date}</div>
            <div>{time}</div>
          </div>
          <div className="row-cell w5">
            <div className="fa-center justify-content-end">
              <div>
                <span
                  className={`cpt-5 cpb-5 cps-10 br-12 ${
                    isDarkMode ? "color-ffff" : "color-2749"
                  } text-16-500`}
                >
                  {amount}
                </span>
              </div>
            </div>
          </div>
          <div className="row-cell w20">
            <div className="fa-center">
              <div>
                <span className="cpt-5 cpb-5 cps-10 cpe-10 br-12 color-2749 text-16-500">
                  <span className="cpt-5 cpb-5 cps-10 cpe-10 br-8 bg-56ff text-14-500 color-ffff">
                    {currency ? currency.toUpperCase() : "FUND"}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div className="row-cell w20">
            <div className="fa-center">
              <div>
                <span
                  className={`cpt-5 cpb-5 cps-10 cpe-10 br-12 ${
                    isDarkMode ? "color-ffff" : "color-2749"
                  } text-16-500`}
                >
                  {queries}
                </span>
              </div>
            </div>
          </div>
          <div className="row-cell ">
            <div className="fa-center">
              <div>
                <span
                  className={`cpt-5 cpb-5 cps-10 cpe-10 br-12 ${
                    isDarkMode ? "color-ffff" : "color-2749"
                  } text-16-500`}
                >
                  {currency === "FUND" || currency === ""
                    ? `Queries/Min`
                    : "Total Queries"}
                </span>
              </div>
            </div>
          </div>
        </div>
      ),
    });
  });

  return (
    <div id="transaction-container" className="cps-38 cpe-38 cpt-26 cpb-24">
      {pageLoading ? (
        <>
          <div
            className={`${isDarkMode ? "skeleton-dark" : "skeleton"} h-45 br-4`}
          />
          <div
            className={`cmt-26 cp-24 ${
              isDarkMode ? "bg-102a" : "bg-f9fb"
            } flex-grow-1 d-flex flex-column`}
          >
            <div
              className={`${
                isDarkMode ? "skeleton-dark" : "skeleton"
              } h-45 br-4`}
            />
            <div
              className={`${
                isDarkMode ? "skeleton-dark" : "skeleton"
              } h-45 br-4 cmt-36 flex-grow-1`}
            />
          </div>
        </>
      ) : (
        <>
          <div className="fb-center">
            <div
              className={`text-20-700 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              Transactions
            </div>
            <div className="fa-center gap-3">
              <Button
                btnStyle="DO"
                leftIcon={icons.wallet}
                btnText={`${tokenBalance} ${
                  globalChainID === 1
                    ? "FUNDx"
                    : globalChainID === 137
                    ? "fxFUNDx"
                    : "FUND"
                }`}
                onClick={() => {}}
                className="cps-20 cpe-20 b-dee3 text-14-600 color-2749"
              />
              <Button
                btnStyle="PD"
                btnText="View Streams"
                onClick={() => {
                  setShow(true);
                }}
              />
            </div>
          </div>
          <div
            className={`cmt-26 cp-24  ${
              isDarkMode ? "bg-102a" : "bg-f9fb"
            } flex-grow-1 d-flex flex-column`}
          >
            <div
              className={`${isDarkMode ? "table-block-dark" : "table-block"}`}
            >
              <div className="header-block">
                {headerOption.map((elem, index) => {
                  const { elemValue } = elem;

                  return (
                    <React.Fragment key={index}>{elemValue}</React.Fragment>
                  );
                })}
              </div>
              <div
                className={`body-block ${
                  isDarkMode ? "custom-scroll-dark" : "custom-scroll"
                }`}
              >
                {rowData.map((elem, index) => {
                  const { rowValue } = elem;
                  return (
                    <React.Fragment key={index}>{rowValue}</React.Fragment>
                  );
                })}
                {displayList.length === 0 && (
                  <div className="f-center h-100">
                    <div>
                      <div style={{ height: "100px" }}>
                        <img
                          src={
                            isDarkMode
                              ? icons.emptyProjectLight
                              : icons.emptyProject
                          }
                          alt="emptyProject"
                          className="fit-image"
                        />
                      </div>
                      <div
                        className={`text-16-600 ${
                          isDarkMode ? "color-ffff" : "color-2749"
                        } mt-3`}
                      >
                        Change to the network you created your subscription
                        <br />
                        (Polygon, ethereum) to see/modify your transactions
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {displayList.length > 0 && (
                <div className="footer-block">
                  <div className="text-14-500 un">
                    <span
                      className={`${isDarkMode ? "color-c9c9" : "color-2749"}`}
                    >
                      Showing {offset} to{" "}
                      {activePage * limit > total ? total : activePage * limit}{" "}
                      of
                    </span>
                    <span className="color-56ff"> {total} entries</span>
                  </div>
                  <div className="fa-center">
                    {option.length > 0 && total > 5 && (
                      <div
                        className={`fa-center ${
                          isDarkMode ? "dropdownStyle" : ""
                        }`}
                      >
                        <div
                          className={`text-14-500 ${
                            isDarkMode ? "color-ffff" : "color-2749"
                          } cme-10 un`}
                        >
                          Display
                        </div>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                          >
                            <div
                              className={`fa-center  ${
                                isDarkMode ? "b-4d6c" : "b-edf0"
                              } br-4 pt-1 pb-1 ps-2 pe-2 gap-2 pointer`}
                            >
                              <span
                                className={`un ${
                                  isDarkMode ? "color-ffff" : "color-2749"
                                } w-20`}
                              >
                                {limit}
                              </span>
                              <span>
                                <img
                                  src={
                                    isDarkMode
                                      ? icons.paginationLight
                                      : icons.pagination
                                  }
                                  alt="pagination"
                                  className="fit-image"
                                />
                              </span>
                            </div>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {option.map((elm, index) => {
                              return (
                                <Dropdown.Item
                                  key={index}
                                  className={`text-14-400 ${
                                    isDarkMode ? "color-ffff" : "color-2749"
                                  } ${
                                    option.length - 1 === index
                                      ? ""
                                      : "pb-2 bb-dee3"
                                  }`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handlePagination("limit", {
                                      limitset: elm,
                                    });
                                  }}
                                >
                                  {elm}
                                </Dropdown.Item>
                              );
                            })}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    )}
                    {totalPage > 1 && (
                      <div className="fa-center gap-2 cms-30">
                        <div
                          className={`icon-btn ${
                            activePage !== 1 ? "active-icon-btn" : ""
                          }`}
                          onClick={() => {
                            if (activePage !== 1) {
                              handlePagination("prev", {
                                activePage: activePage,
                              });
                            }
                          }}
                        >
                          <img
                            src={
                              activePage !== 1
                                ? icons.lightArrowLeft
                                : icons.darkArrowLeft
                            }
                            alt="darkArrowLeft"
                            className="fit-image"
                          />
                        </div>
                        <div
                          className={`page-btn ${
                            activePage === page1 ? "active-page-btn" : ""
                          }`}
                          onClick={() => {
                            handlePagination("page", { page: page1 });
                          }}
                        >
                          {page1}
                        </div>
                        <div
                          className={`page-btn ${
                            activePage === page2 ? "active-page-btn" : ""
                          }`}
                          onClick={() => {
                            handlePagination("page", { page: page2 });
                          }}
                        >
                          {page2}
                        </div>
                        <div
                          className={`page-btn ${
                            activePage === page3 ? "active-page-btn" : ""
                          } ${totalPage > 2 ? "" : "d-none"}`}
                          onClick={() => {
                            handlePagination("page", { page: page3 });
                          }}
                        >
                          {page3}
                        </div>
                        <div
                          className={`icon-btn ${
                            activePage !== totalPage ? "active-icon-btn" : ""
                          }`}
                          onClick={() => {
                            if (activePage !== totalPage) {
                              handlePagination("next", {
                                activePage: activePage,
                              });
                            }
                          }}
                        >
                          <img
                            src={
                              activePage !== totalPage
                                ? icons.lightArrowRight
                                : icons.darkArrowRight
                            }
                            alt="lightArrowRight"
                            className="fit-image"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Transaction;
